"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _userIsSystemAdmin = _interopRequireDefault(require("../../../../../schema/security/user-is-system-admin"));
var _editableField = _interopRequireDefault(require("../../../../core/editable-field"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "Days on which new races start:");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "There are no days in competition!");
class DivisionRaceStartDays extends _react.Component {
  render() {
    const divisionRaceStartDays = this.props.division.divisionRaceStartDays;
    const competitionDays = this.props.competitionDays;
    return /*#__PURE__*/_react.default.createElement("div", null, _ref, !competitionDays.length ? _ref2 : competitionDays.map(cDay => /*#__PURE__*/_react.default.createElement(_editableField.default, {
      key: cDay.id,
      enabled: (0, _userIsSystemAdmin.default)(this.props.user),
      type: "Checkbox",
      name: cDay.dayDate,
      label: (0, _occasion.default)(cDay.dayDate, 'dddd'),
      checked: divisionRaceStartDays.includes(cDay.id),
      onChange: value => this.props.onUpsertStartDay(cDay.id, value)
    })));
  }
  // ****************************************************************************
  // PartialQuery definition
  // ****************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(DivisionRaceStartDays, "partials", {
  Division: {
    id: true,
    divisionRaceStartDays: true
  },
  CompetitionDays: {
    id: true,
    dayDate: true
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(DivisionRaceStartDays, undefined, (client, props) => ({
  onUpsertStartDay(competitionDayID, isRacingStartDay) {
    return client.update('CompetitionDivision.upsertDivisionRacing', {
      competitionDivisionID: props.division.id,
      competitionDayID,
      isRacingStartDay
    });
  }
}));